import { adminApiFetch } from './adminApi.js';
import { devError } from './logger.js';

/**
 * 郵便番号検索ユーティリティ
 * AdminHub API 経由で zipcloud 郵便番号検索を利用
 */

/**
 * 郵便番号から住所を検索
 * @param {string} postalCode - 郵便番号（ハイフンあり/なし両方対応）
 * @returns {Promise<{success: boolean, address: string, prefecture: string, city: string, town: string, error?: string}>}
 */
export async function searchAddressByPostalCode(postalCode) {
  try {
    const normalizedCode = postalCode.replace(/[^\d]/g, '');

    if (normalizedCode.length !== 7) {
      return {
        success: false,
        address: '',
        prefecture: '',
        city: '',
        town: '',
        error: '郵便番号は7桁で入力してください',
      };
    }

    return await adminApiFetch(`/api/admin/postal-code/search?zipcode=${encodeURIComponent(normalizedCode)}`);
  } catch (error) {
    devError('郵便番号検索エラー:', error);
    return {
      success: false,
      address: '',
      prefecture: '',
      city: '',
      town: '',
      error: error.message || 'ネットワークエラーが発生しました',
    };
  }
}

/**
 * 郵便番号をフォーマット（xxx-xxxx形式）
 * @param {string} postalCode - 郵便番号
 * @returns {string} フォーマットされた郵便番号
 */
export function formatPostalCode(postalCode) {
  const numbers = postalCode.replace(/[^\d]/g, '');

  if (numbers.length < 3) {
    return numbers;
  }

  if (numbers.length <= 7) {
    return numbers.slice(0, 3) + (numbers.length > 3 ? '-' + numbers.slice(3, 7) : '');
  }

  return numbers.slice(0, 3) + '-' + numbers.slice(3, 7);
}

/**
 * 郵便番号の入力値を検証
 * @param {string} postalCode - 郵便番号
 * @returns {{valid: boolean, error: string}} 検証結果
 */
export function validatePostalCode(postalCode) {
  const normalizedCode = postalCode.replace(/[^\d]/g, '');

  if (normalizedCode.length === 0) {
    return { valid: true, error: '' };
  }

  if (normalizedCode.length !== 7) {
    return { valid: false, error: '郵便番号は7桁で入力してください' };
  }

  return { valid: true, error: '' };
}
